import {
  type PaidSpecContractType,
  type SpecContractType,
} from '@/common/types/contract';

import customImagePng from '/img/contract/folder.png';
import customImageWebp from '/img/contract/folder.webp';
import blitzImagePng from '/img/contract/plane.png';
import blitzImageWebp from '/img/contract/plane.webp';
import grandImagePng from '/img/contract/ship.png';
import grandImageWebp from '/img/contract/ship.webp';
import goldenImagePng from '/img/contract/truck.png';
import goldenImageWebp from '/img/contract/truck.webp';

const goldenImage = { img: goldenImagePng, webp: goldenImageWebp };
const grandImage = { img: grandImagePng, webp: grandImageWebp };
const blitzImage = { img: blitzImagePng, webp: blitzImageWebp };

const imageConfigs: Record<
  SpecContractType | PaidSpecContractType,
  { image: { img: string; webp: string } }
> = {
  Custom: { image: { img: customImagePng, webp: customImageWebp } },
  Golden: { image: goldenImage },
  GoldenPlus: { image: goldenImage },
  Grand: { image: grandImage },
  GrandPlus: { image: grandImage },
  Blitz: { image: blitzImage },
  BlitzPlus: { image: blitzImage },
};

const defaultDescription =
  'Your chance to reach a new income level. Ready for a real profit hunt?';

const description: Record<SpecContractType | PaidSpecContractType, string> = {
  Custom: 'Make your own contract. Ready to grab the best deal?',
  Golden: defaultDescription,
  GoldenPlus: defaultDescription,
  Grand: defaultDescription,
  GrandPlus: defaultDescription,
  Blitz: defaultDescription,
  BlitzPlus: defaultDescription,
};

export { description, imageConfigs };
